
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "FPTC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/FPTC.vue